// extracted by mini-css-extract-plugin
export var dropdownContainer = "_lp-0";
export var leftAlign = "_lp-4";
export var listItem = "_lp-2";
export var listItemWrapper = "_lp-1";
export var operationText = "_lp-3";